module.exports = __webpack_public_path__ + "static/media/ppicon4.c6e0783d.svg";